export default {
    'halls.loading': 'Загрузка',
    'halls.primary.title': 'Практика',
    'halls.middle.title': 'Эксперт',
    'halls.high.title': 'Элита',
    'halls.top.title': 'Мастер',
    'halls.level.describe': 'Условия зала',
    'halls.coin.not': 'Недостаточно монет',
    'halls.setting.title': 'Настройка',
};